import { render, staticRenderFns } from "./ZfbPaySetting.vue?vue&type=template&id=3bf87d50&scoped=true"
import script from "./ZfbPaySetting.vue?vue&type=script&lang=js"
export * from "./ZfbPaySetting.vue?vue&type=script&lang=js"
import style0 from "./ZfbPaySetting.vue?vue&type=style&index=0&id=3bf87d50&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf87d50",
  null
  
)

export default component.exports